// Assets/utm-persist.js
(function () {
  const UTM_KEYS = ["kb", "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

  // Optional: wenn du zusätzliches Click-ID-Tracking willst, ergänzen:
  // const EXTRA_KEYS = ["gclid", "fbclid", "msclkid"];
  // const KEYS = [...UTM_KEYS, ...EXTRA_KEYS];
  const KEYS = UTM_KEYS;

  const EXCLUDE_PATH_PREFIXES = [
    "/checkout",
    "/cart",
    "/account",
    "/admin"
  ];

  function isExcludedPath(pathname) {
    return EXCLUDE_PATH_PREFIXES.some((p) => pathname.startsWith(p));
  }

  function storeFromCurrentUrl() {
    const sp = new URLSearchParams(window.location.search);
    let storedAny = false;

    KEYS.forEach((k) => {
      const v = sp.get(k);
      if (v) {
        sessionStorage.setItem(k, v);
        storedAny = true;
      }
    });

    return storedAny;
  }

  function getStoredParams() {
    const sp = new URLSearchParams();
    KEYS.forEach((k) => {
      const v = sessionStorage.getItem(k);
      if (v) sp.set(k, v);
    });
    return sp;
  }

  function mergeParamsIntoUrl(url) {
    const stored = getStoredParams();
    if (!stored.toString()) return url;

    // schon vorhandene Parameter nicht überschreiben
    stored.forEach((value, key) => {
      if (!url.searchParams.has(key)) url.searchParams.set(key, value);
    });

    return url;
  }

  function isInternalLink(url) {
    // gleiche Origin (dein Shop-Domain). Relative URLs werden unten eh mit base aufgelöst.
    return url.origin === window.location.origin;
  }

  function shouldSkipLink(a) {
    if (!a || !a.getAttribute) return true;

    const href = a.getAttribute("href");
    if (!href) return true;

    // keine Sonderprotokolle anfassen
    if (href.startsWith("mailto:") || href.startsWith("tel:") || href.startsWith("sms:")) return true;
    if (href.startsWith("#")) return true;

    // explizit externe Links nicht anfassen
    if (a.hasAttribute("data-no-utm")) return true;

    return false;
  }

  function rewriteAllLinksIn(container) {
    const root = container || document;
    const links = root.querySelectorAll('a[href]');
    links.forEach((a) => {
      if (shouldSkipLink(a)) return;

      let url;
      try {
        url = new URL(a.getAttribute("href"), window.location.origin);
      } catch (e) {
        return;
      }

      if (!isInternalLink(url)) return;
      if (isExcludedPath(url.pathname)) return;

      url = mergeParamsIntoUrl(url);
      a.setAttribute("href", url.toString());
    });
  }

  function ensureCurrentUrlHasParams() {
    const stored = getStoredParams();
    if (!stored.toString()) return;

    const current = new URL(window.location.href);

    // Nur ergänzen (nicht überschreiben)
    let changed = false;
    stored.forEach((value, key) => {
      if (!current.searchParams.has(key)) {
        current.searchParams.set(key, value);
        changed = true;
      }
    });

    if (changed) {
      // URL in der Adresszeile aktualisieren ohne Reload
      window.history.replaceState({}, "", current.toString());
    }
  }

  // 1) UTMs vom Entry speichern
  storeFromCurrentUrl();

  // 2) (Optional) aktuelle URL ergänzen, wenn schon UTMs in der Session sind
  ensureCurrentUrlHasParams();

  // 3) Links beim Laden umschreiben
  document.addEventListener("DOMContentLoaded", function () {
    rewriteAllLinksIn(document);

    // 4) Event-Delegation: auch Links, die später per JS/Ajax reinkommen
    document.addEventListener("click", function (e) {
      const a = e.target && e.target.closest ? e.target.closest("a[href]") : null;
      if (!a || shouldSkipLink(a)) return;

      let url;
      try {
        url = new URL(a.getAttribute("href"), window.location.origin);
      } catch (err) {
        return;
      }

      if (!isInternalLink(url)) return;
      if (isExcludedPath(url.pathname)) return;

      url = mergeParamsIntoUrl(url);
      a.setAttribute("href", url.toString());
    }, true);
  });

})();